import { start } from "nprogress";

const landingPageTranslations = {
  welcomeCard: {
    title: "هل أنت جاهز؟",
    description:
      "المجد الأكبر في الحياة لا يكمن في عدم السقوط أبدًا، بل في النهوض كل مرة نسقط.",
    actionButtons: {
      contactUs: "تواصل معنا",
      watchTutorial: "شاهد الشرح",
    },
  },
  quickNavigations: {
    title: "جاهز يا وحش",
    nutritionPlan: "البرنامج الغذائي",
    workoutPlan: "البرنامج التدريبي",
    startDate: "تاريخ البداية",
    endDate: {
      title: "تاريخ الانتهاء",
      callToAction: "تفعيل Freeze",
    },
  },
};

export default landingPageTranslations;
